export function NavIconMenu() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-[18px] w-[18px]" aria-hidden>
      <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function NavIconChevronLeft() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-3 w-3" aria-hidden>
      <path d="m15 18-6-6 6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function NavIconChevronRight() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-3 w-3" aria-hidden>
      <path d="m9 18 6-6-6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function NavIconHome({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M3 11 12 4l9 7v9a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1v-9Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <path d="M3 11 12 4l9 7v9a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1v-9Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

export function NavIconPlug({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M9 3v4h6V3h2v4h1a1 1 0 0 1 1 1v4a6 6 0 0 1-5 5.91V21h-4v-3.09A6 6 0 0 1 5 12V8a1 1 0 0 1 1-1h1V3h2Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <path d="M9 3v4M15 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M6 7h12v4a6 6 0 0 1-6 6 6 6 0 0 1-6-6V7Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M12 17v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function NavIconList({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <rect x="3" y="5" width="18" height="2.5" rx="1.25" />
      <rect x="3" y="11" width="18" height="2.5" rx="1.25" />
      <rect x="3" y="17" width="10" height="2.5" rx="1.25" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function NavIconCalendar({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 16H5v-9h14v9Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function NavIconArchive({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm1 5h16v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9Zm6 3a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2h-4Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <rect x="3" y="4" width="18" height="4" rx="1" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8" stroke="currentColor" strokeWidth="1.8" />
      <path d="M10 12h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function NavIconCloud({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M12 13v7m0 0-3-3m3 3 3-3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M17.5 9.07A6.5 6.5 0 0 0 6.22 11.4 4 4 0 1 0 7 19h4v-6.59l-1.7 1.7-1.42-1.42L12 9.58l4.12 4.12-1.42 1.41L13 13.42V19h4a4 4 0 0 0 .5-7.93Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <path d="M7 18a4 4 0 0 1-.5-7.97A6 6 0 0 1 18 9.5a3.5 3.5 0 0 1 .5 6.95" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M12 13v7m0 0-3-3m3 3 3-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function NavIconShield({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M12 2 4 5v6c0 5.25 3.5 9 8 10 4.5-1 8-4.75 8-10V5l-8-3Zm-1 11.59-2.3-2.3-1.4 1.42L11 17l6-6-1.41-1.41L11 13.59Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <path d="M12 3 4 6v6c0 5 3.5 8.5 8 9 4.5-.5 8-4 8-9V6l-8-3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function NavIconCog({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-8.94 3A8.06 8.06 0 0 1 4 9.46l-1.4-1.08A10 10 0 0 0 1 12c0 1.28.24 2.5.67 3.62L3.07 14.5A8 8 0 0 1 3.06 11Zm17.88 0a8 8 0 0 1-.01 2.5l1.4 1.12c.43-1.12.67-2.34.67-3.62a10 10 0 0 0-2.6-6.62L19 5.46A8.06 8.06 0 0 1 20.94 11ZM19 5.46l-1.08 1.4A8 8 0 0 0 14.54 5L14 3.06A10 10 0 0 1 19 5.46ZM5 5.46A10 10 0 0 1 10 3.06L9.46 5a8 8 0 0 0-3.38 1.86L5 5.46Zm-.94 9.62 1.4-1.12A8 8 0 0 0 9.46 19L10 20.94A10 10 0 0 1 4.06 15.08ZM14 20.94l.54-1.94a8 8 0 0 0 3.38-1.86l1.38 1.08A10 10 0 0 1 14 20.94Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

export function NavIconRadar({ active }: { active?: boolean }) {
  return active ? (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full" aria-hidden>
      <path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2Zm0 2a8 8 0 0 1 5.66 13.66l-1.45-1.45A6 6 0 1 0 6.34 7.8L4.89 6.35A8 8 0 0 1 12 4Zm0 3a5 5 0 0 1 3.54 8.54l-1.42-1.42a3 3 0 1 0-4.24-4.24L8.46 8.46A5 5 0 0 1 12 7Zm0 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.8" />
      <line x1="12" y1="2" x2="12" y2="4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="12" y1="20" x2="12" y2="22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="2" y1="12" x2="4" y2="12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="20" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function SignOutIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-full w-full" aria-hidden>
      <path d="M15 12H4m0 0 4-4m-4 4 4 4M9 4h7a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
